import { clsx } from 'clsx';
import React, { useMemo } from 'react';
import { SemanticType } from '../FileCard';
import { getSize } from '../utils';

interface FileProps {
  styles?: Partial<Record<SemanticType, React.CSSProperties>>;
  classNames?: Partial<Record<SemanticType, string>>;
  prefixCls?: string;
  name?: string;
  ext?: string;
  size?: 'small' | 'default';
  byte?: number;
  description?: React.ReactNode;
  icon?: React.ReactNode;
  iconColor?: string;
  onClick?: () => void;
  mask?: React.ReactNode;
}

const File: React.FC<FileProps> = (props) => {
  const {
    styles = {},
    classNames = {},
    prefixCls,
    name,
    ext,
    size,
    byte,
    description,
    icon,
    iconColor,
    onClick,
    mask,
  } = props;
  const compCls = `${prefixCls}-file`;

  const mergedCls = clsx(compCls, classNames.file, {
    [`${compCls}-pointer`]: !!onClick,
    [`${compCls}-small`]: size === 'small',
  });

  const desc = useMemo(() => {
    if (description) {
      return description;
    }
    if (typeof byte === 'number') {
      return getSize(byte);
    }
    return '';
  }, [description, byte]);

  return (
    <div className={mergedCls} style={styles.file} onClick={onClick}>
      <div
        className={clsx(`${compCls}-icon`, classNames.icon)}
        style={{ color: iconColor, ...styles.icon }}
      >
        {icon}
      </div>
      <div className={`${compCls}-content`}>
        <div className={clsx(`${compCls}-name`, classNames.name)} style={styles.name}>
          <span className={`${compCls}-name-prefix`}>{name}</span>
          <span className={`${compCls}-name-suffix`}>{ext}</span>
        </div>
        {desc && (
          <div
            className={clsx(`${compCls}-description`, classNames.description)}
            style={styles.description}
          >
            {desc}
          </div>
        )}
      </div>
      {mask && (
        <div className={`${compCls}-mask`}>
          <div className={`${compCls}-mask-info`}>{mask}</div>
        </div>
      )}
    </div>
  );
};

export default File;
